import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import Functions from './functions'
import Variable from './variable'
import Axios from 'axios'
import ComComboBox from '@/components/com_combobox.vue'
import ComToolbarDefault from '@/components/com_toolbar_default.vue'
import ComConfirmDefault from '@/components/com_confirm_default.vue'
import ComBottomDefault from '@/components/com_bottom_default.vue'
import ComToolbarCustom from '@/components/com_toolbar_custom.vue'
import ComToolbarAvatar from '@/components/com_toolbar_avatar.vue'
import ComDownload from '@/components/com_download.vue'
import ComLogin from '@/components/com_login.vue'
import ComSnackbar from '@/components/com_snackbar.vue'
import ComChangePassword from '@/components/com_changepassword.vue'
import ComAttachmentList from '@/components/com_attachment_list.vue'
import ComCaptCha from '@/components/com_captcha.vue'
import VueQrcodeReader from 'vue-qrcode-reader'

import CKEditor from "@ckeditor/ckeditor5-vue2"
// Infinite Loading
import InfiniteLoading from 'vue-infinite-loading'
// Moment JS
import moment from 'moment'
//currency format
import AppNumber from '@/components/com_number.vue'

import "./plugins/vuetify-money.js"

Vue.config.productionTip = false

const plugins = {
  install () {
    Vue.functions = Functions
    Vue.prototype.$functions = Functions
  }
}
const apps = {
  install () {
    Vue.vars = Variable
    Vue.prototype.$vars = Variable
  }
}
Vue.prototype.$axios = Axios
Vue.use(plugins)
Vue.use(apps)
// Format Money
Vue.use(AppNumber)
Vue.use(CKEditor)
Vue.use(VueQrcodeReader)
// Infinite Loading
Vue.use(InfiniteLoading, {
  slots: {
    noMore: 'Tidak ada data lagi', // you can pass a string value
    noResults: '' // you can pass a string value
  }
})
Vue.prototype.$moment = moment
Vue.component('app-login',ComLogin)
Vue.component('app-cb',ComComboBox)
Vue.component('app-toolbardefault',ComToolbarDefault)
Vue.component('app-confirmdefault',ComConfirmDefault)
Vue.component('app-bottomdefault',ComBottomDefault)
Vue.component('app-toolbarcustom',ComToolbarCustom)
Vue.component('app-toolbaravatar',ComToolbarAvatar)
Vue.component('app-download',ComDownload)
Vue.component('app-snackbar',ComSnackbar)
Vue.component('app-changepassword',ComChangePassword)
Vue.component('app-attachment-list',ComAttachmentList)

Vue.component('app-number',AppNumber)

// Captcha
Vue.component('app-captcha',ComCaptCha)

require('../src/assets/css/my.css')

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
